import { useDataListContext } from './DataList';
import ListHeader, { type ListHeaderProps } from './ListHeader';
import type { FieldValues } from 'react-hook-form';

export default function DataListHeader<T extends FieldValues>(
  props: Omit<ListHeaderProps<T>, 'filterFields' | 'title'>
) {
  const { filterFields, title } = useDataListContext<T>();
  return <ListHeader<T> {...props} filterFields={filterFields} title={title} />;
}
